(function () {
  var qs = function (s, r) { return (r || document).querySelector(s); };
  var qsa = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* drawer */
  var drawer = qs('#drawer'), scrim = qs('#scrim');
  function openDrawer() { drawer.classList.add('is-open'); scrim.classList.add('is-open'); }
  function closeDrawer() { drawer.classList.remove('is-open'); scrim.classList.remove('is-open'); }
  var menuBtn = qs('#menuBtn'); if (menuBtn) menuBtn.addEventListener('click', openDrawer);
  var drawerClose = qs('#drawerClose'); if (drawerClose) drawerClose.addEventListener('click', closeDrawer);
  if (scrim) scrim.addEventListener('click', closeDrawer);
  if (drawer) qsa('nav a', drawer).forEach(function (a) { a.addEventListener('click', closeDrawer); });

  /* cart count */
  function setCartCount(n) { var el = qs('#cartCount'); if (el) el.textContent = n; }
  function refreshCart() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { setCartCount(c.item_count); }).catch(function () {});
  }

  /* buy box */
  var opts = qsa('.opt');
  function selectedOpt() { return qs('.opt.is-active') || opts[0]; }
  function updateTotals() {
    var o = selectedOpt(); if (!o) return;
    var amt = qs('#buyTotal'), save = qs('#buySave');
    if (amt) amt.textContent = o.getAttribute('data-price-label') || '';
    if (save) save.textContent = o.getAttribute('data-save-label') || '';
  }
  opts.forEach(function (o) {
    o.addEventListener('click', function () {
      opts.forEach(function (x) { x.classList.remove('is-active'); });
      o.classList.add('is-active');
      updateTotals();
    });
  });
  updateTotals();

  var addBtn = qs('#buyAdd');
  if (addBtn) addBtn.addEventListener('click', function () {
    var o = selectedOpt(); if (!o) return;
    var id = o.getAttribute('data-variant-id'); if (!id) return;
    addBtn.disabled = true;
    var original = addBtn.textContent;
    addBtn.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(id, 10), quantity: 1 })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return r.json();
    }).then(function () {
      refreshCart();
      addBtn.textContent = 'Added ✓';
      setTimeout(function () { addBtn.textContent = original; addBtn.disabled = false; }, 1600);
    }).catch(function () {
      addBtn.textContent = 'Try again';
      addBtn.disabled = false;
    });
  });

  /* trio shortcut */
  qsa('[data-pick-trio]').forEach(function (b) {
    b.addEventListener('click', function () {
      var trio = opts[1];
      if (trio) {
        opts.forEach(function (x) { x.classList.remove('is-active'); });
        trio.classList.add('is-active');
        updateTotals();
      }
      var buy = qs('#buy');
      if (buy) window.scrollTo({ top: buy.getBoundingClientRect().top + window.scrollY - 70, behavior: 'smooth' });
    });
  });

  /* accordions */
  qsa('.acc__btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.parentElement;
      var panel = qs('.acc__panel', item);
      var open = item.classList.contains('is-open');
      qsa('.acc__item.is-open').forEach(function (i) {
        i.classList.remove('is-open');
        var p = qs('.acc__panel', i); if (p) p.style.maxHeight = '0px';
      });
      if (!open) {
        item.classList.add('is-open');
        if (panel) panel.style.maxHeight = panel.scrollHeight + 'px';
      }
    });
  });

  /* reviews */
  var reviews = qsa('.review'), dots = qsa('.dot');
  var current = 0, timer = null;
  function showReview(i) {
    current = i;
    reviews.forEach(function (r, j) { r.classList.toggle('is-active', j === i); });
    dots.forEach(function (d, j) { d.classList.toggle('is-active', j === i); });
  }
  if (reviews.length) {
    dots.forEach(function (d, i) {
      d.addEventListener('click', function () { showReview(i); restart(); });
    });
    function restart() { if (timer) clearInterval(timer); timer = setInterval(function () { showReview((current + 1) % reviews.length); }, 6000); }
    showReview(0); restart();
  }

  /* signup forms (placeholder until a mail app is connected) */
  qsa('[data-signup]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var msg = qs('.field__msg', form.parentElement);
      var input = qs('input', form);
      if (input && input.value.trim()) {
        if (msg) msg.textContent = form.getAttribute('data-signup');
        input.value = '';
      } else if (msg) {
        msg.textContent = 'Please enter a value first.';
      }
    });
  });

  refreshCart();
})();
